module.exports = __webpack_public_path__ + "img/time.8ff71fe4.svg";